export class Mutex {
  // initialize the tail with a resolved promise
  private tailOfExecution = Promise.resolve();

  async withLock<T>(criticalFunction: () => Promise<T>): Promise<T> {
    // ssave the tail
    const previousExecution = this.tailOfExecution;

    let completeTheTail: () => void;
    // will be awaited by the next call to withLock
    this.tailOfExecution = new Promise<void>(resolve => (completeTheTail = resolve));

    await previousExecution;
    try {
      return await criticalFunction();
    } finally {
      completeTheTail!();
    }
  }

}